// extracted by mini-css-extract-plugin
export default {"header":"Accounts_header__DRo-3","title":"Accounts_title__w2oNI","formContainer":"Accounts_formContainer__Abj8H","createAccountInputField":"Accounts_createAccountInputField__0AYuF"};